export default __webpack_public_path__ + "static/media/aliveclass_thumb01.eed29e2b.png";